import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsCycleTimeRoute: InvariantJiraRoute = {
	name: 'software-reports-cycle-time',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time',
};
